module.exports = __webpack_public_path__ + "static/media/Prototyping_Tool.73d2b595.jpg";